// Module
var code = "<form name=\"$ctrl.form.formAttribut\" class=\"panel-body\"> <oo-admin-attribute-editor node=\"$ctrl.node\" ng-model=\"$ctrl.form.attribut\" form=\"$ctrl.form.formAttribut\" ng-disabled=\"$ctrl.disabled\"></oo-admin-attribute-editor> </form> ";
// Exports
export default code;